<div class="guest-catalog">
    <div class="guest-catalog-chips" *ngIf="ShowChips" uppDataid="guestcatalog-chips">
        <upp-scrollable #chipsScroll scrollbar="x">
            <div class="guest-catalog-chips-row">
                <ion-chip
                    *ngFor="let section of sections; let i = index; trackBy: SectionTrack"
                    #chipEl
                    class="guest-catalog-chip"
                    uppDataid="guestcatalog-chip"
                    [color]="i === ActiveSectionIndex ? 'primary' : undefined"
                    [outline]="i !== ActiveSectionIndex"
                    (click)="OnChipSelect(i)"
                >
                    <ion-label *ngIf="section.group">{{tr(section.group.name)}}</ion-label>
                    <ion-label *ngIf="!section.group">{{tr('@guest_order_section_other')}}</ion-label>
                </ion-chip>
            </div>
        </upp-scrollable>
    </div>

    <upp-scrollable #listScroll scrollbar="y" *ngIf="!IsEmpty">
        <div class="guest-catalog-list">
            <ng-container *ngIf="!Searching">
                <section #sectionEl class="guest-catalog-section" *ngFor="let section of sections; trackBy: SectionTrack">
                    <h2 class="guest-catalog-title" *ngIf="section.group">
                        {{tr(section.group.name)}}
                    </h2>
                    <h2 class="guest-catalog-title" *ngIf="!section.group">
                        {{tr('@guest_order_section_other')}}
                    </h2>

                    <upp-form-section fill="solid">
                        <ng-container *ngFor="let entry of section.entries; trackBy: EntryTrack">
                            <h3 class="guest-catalog-subtitle" *ngIf="entry.kind === 'subtitle'">
                                {{tr(entry.group.name)}}
                            </h3>
                            <upp-guest-row *ngIf="entry.kind === 'product'"
                                [product]="entry.product"
                                [ticket]="ticket"
                                (Select)="OnSelect($event)"
                            ></upp-guest-row>
                            <upp-guest-row *ngIf="entry.kind === 'preselect'"
                                [product]="entry.select"
                                [ticket]="ticket"
                                (Select)="OnSelect($event)"
                            ></upp-guest-row>
                        </ng-container>
                    </upp-form-section>
                </section>
            </ng-container>

            <ng-container *ngIf="Searching">
                <upp-guest-row
                    *ngFor="let product of searchRows; trackBy: ProductTrack"
                    [product]="product"
                    [ticket]="ticket"
                    (Select)="OnSelect($event)"
                ></upp-guest-row>
            </ng-container>
        </div>
    </upp-scrollable>
</div>
